export default {
      id: "calendar-usage",
      viewBox: "0 0 21.92 24.14",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#calendar",
      toString: function () {
        return this.url;
      }
    }